import { LinkIcon } from '~/appComponents/LinkIcon.tsx'

function LeaveFeedbackLink() {
  return (
    <ul className="main-menu__list main-menu__list--feedback">
      <li className="main-menu__item">
        <a
          className="main-menu__link main-menu__link--feedback"
          href="https://survey.typeform.com/to/gTDhvVoF"
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="main-menu__icon main-menu__icon--default">
            <LinkIcon type="leave-feedback" />
          </div>
          <span className="main-menu__item-name link-external">Leave feedback</span>
        </a>
      </li>
    </ul>
  )
}

export default LeaveFeedbackLink
